import React from 'react';
import Header from '../../components/Header/Header';

const Contact = () => {
    return (
        <div>
            <Header forceHideHamburger />
            <div className="contact-section">
                <h1>Contact</h1>
                <div className="contact-info">
                    <p>
                        Help desk email: <a href="mailto:uk@content-clubs.com">uk@content-clubs.com</a>
                    </p>
                    <p>Help contact number: 08085015606</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
